import React, { Component } from "react";
import ReactToPrint from "react-to-print";
// import PatientsReport from "./Report.Patients";
import PatientsReport from "./Patients/Report.Patients";
import AccountsReport from "./Account/Report.Account";
import MedStockReport from "./Medicine/Report.MedicineStock";
import MedicineReport from "./Medicine/Report.Medicine";
import EquipmentReport from "./Equipment/Report.Equipment";
import MedExpiryReport from "./Medicine/Report.MedicineExpiry";
import MedThresholdReport from "./Medicine/Report.MedicineThreshold";
import ReceiptReport from "./Account/Report.Receipt";
import ReceiptReportMultiple from "./Account/Report.ReceiptMultiple";
import DisposeReport from "./Equipment/Report.Dispose";
import DisposeReportMultiple from "./Equipment/Report.DisposeMultiple";

class ReportHome extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let reportComp;

    switch (this.props.reportType) {
      case "Patient":
        reportComp = (
          <PatientsReport
            ref={el => (this.componentRef = el)}
            reportSubType={this.props.reportSubType}
          />
        );
        break;
      case "Accounts":
        reportComp = (
          <AccountsReport
            ref={el => (this.componentRef = el)}
            reportSubType={this.props.reportSubType}
          />
        );
        break;
      case "MedStock":
        reportComp = <MedStockReport ref={el => (this.componentRef = el)} />;
        break;
      case "MedTracker":
        reportComp = <MedicineReport ref={el => (this.componentRef = el)} />;
        break;
      case "Equipment":
        reportComp = (
          <EquipmentReport
            ref={el => (this.componentRef = el)}
            reportSubType={this.props.reportSubType}
          />
        );
        break;
      case "MedExpiry":
        reportComp = <MedExpiryReport ref={el => (this.componentRef = el)} />;
        break;
      case "MedThreshold":
        reportComp = (
          <MedThresholdReport ref={el => (this.componentRef = el)} />
        );
        break;
      case "Receipt":
        reportComp = (
          <ReceiptReport
            ref={el => (this.componentRef = el)}
            data={this.props.data}
          />
        );
        break;
      case "EqDispose":
        reportComp = (
          <DisposeReport
            ref={el => (this.componentRef = el)}
            data={this.props.data}
          />
        );
        break;
      case "EqDisposeMulti":
        reportComp = (
          <DisposeReportMultiple
            ref={el => (this.componentRef = el)}
            data={this.props.data}
          />
        );
        break;
      case "ReceiptMultiple":
        reportComp = (
          <ReceiptReportMultiple
            ref={el => (this.componentRef = el)}
            data={this.props.data}
          />
        );
        break;
    }

    return (
      <div>
        <ReactToPrint
          trigger={() => (
            <button className="btn btn-primary btn-md mr-2">Print</button>
          )}
          content={() => this.componentRef}
          copyStyles={true}
        />
        {reportComp}
      </div>
    );
  }
}

export default ReportHome;
